import { gql } from '@apollo/client';

export const INTEGRATION_EVENT_HOOK_FIELDS = gql`
    fragment IntegrationEventHookFields on integration_event_hooks {
        event_subscription_id
        shipper_id
        carrier_id
        subscribed_event
        url
        override_id
        optional_parameters
        pricing_type
        marketplace_tier
    }
`;
